import React from "react"
import { Message } from "@jjordy/layout"
import uuid from "uuid"
import styled from "styled-components"

const List = styled.ul`
  list-style-type: none;
`

const ListItem = styled.li``

export interface HandleErrorProps {
  error: any
  onClose?: (a?: any) => any
}

export default function HandleError({ error, onClose }: HandleErrorProps) {
  if (error) {
    return (
      <Message bg="red" icon="warning" onClose={onClose}>
        <Message.Content>
          <Message.Header>Something went wrong!</Message.Header>
          <List>
            {error.graphQLErrors &&
              error.graphQLErrors.map((e: Error) => <ListItem key={uuid.v4()}>{e.message}</ListItem>)}
          </List>
          <List>
            {error.errors && error.errors.map((e: Error) => <ListItem key={uuid.v4()}>{e.message}</ListItem>)}
          </List>
        </Message.Content>
      </Message>
    )
  }
  return null
}
